var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-responsive', [_c('h1', [_vm._v("e커머스피칭페스타 지원(리스트)")]), _c('section', {
    staticClass: "mt-4"
  }, [_c('div', [_vm._v("지원 데이터는 "), _c('b', [_vm._v("[관리자 > e커머스피칭페스타 지원]")]), _vm._v(" 페이지에 접속하시면 작성할 수 있습니다.")]), _c('div', {
    staticClass: "mt-8"
  }, [_c('b', [_vm._v("23.04.17")])]), _c('div', [_c('b', [_vm._v(" 실장님 추가 요청) 공고문 상태 추가")])]), _c('div', [_vm._v(" * if 문으로 "), _c('b', [_vm._v("application.status")]), _vm._v(" 모집 상태에 따라 표시할 내용을 다르게 할 수 있습니다.")]), _c('example-layout', {
    staticClass: "overflow-auto mt-4",
    scopedSlots: _vm._u([{
      key: "render",
      fn: function fn() {
        return [_c('example-application-list')];
      },
      proxy: true
    }, {
      key: "editor",
      fn: function fn() {
        return [_c('prism-editor', {
          staticClass: "rounded",
          attrs: {
            "line-numbers": ""
          },
          model: {
            value: _vm.example.section_1.code,
            callback: function callback($$v) {
              _vm.$set(_vm.example.section_1, "code", $$v);
            },
            expression: "example.section_1.code"
          }
        })];
      },
      proxy: true
    }])
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }